<template>
    <div>
        <el-row>
            <el-col :span="9">
                <el-radio-group v-model="filter.status">
                    <el-radio-button :label="null">{{$t('common.all')}}</el-radio-button>
                    <el-radio-button v-for="category in categories"
                                     :label="category.status"
                                     :key="category.status">{{category.total}}{{$i18n.locale == 'en' ? category.name : category.nameFr}}</el-radio-button>
                </el-radio-group>
            </el-col>
            <el-col :span="5">
                <el-input prefix-icon="el-icon-search"
                          v-model="filter.purchaseOrderNumber"
                          :placeholder="$t('orders.purchaseOrderNumber')"></el-input>
            </el-col>
            <el-col :span="5">
                <el-input prefix-icon="el-icon-search"
                          v-model="filter.partOrderNumber"
                          :placeholder="$t('orders.orderNumber')"></el-input>
            </el-col>
            <el-col :span="5">
                <el-input prefix-icon="el-icon-search"
                          v-model="filter.serviceCompanyName"
                          :placeholder="$t('orders.serviceCompanyName')"></el-input>
            </el-col>
        </el-row>
        <el-table size="mini"
                  :data="orders"
                  v-loading="loading"
                  class="orders-table tablewithshading"
                  @sort-change="sortPartOrders">
            <!-- <el-table-column type="expand" v-if="$isFullAdmin">
      <template slot-scope="props">
        <template v-if="props.row.status === 'New'">
          This order is new
        </template>
        <template v-if="props.row.status !== 'New'">
          <tracking-info v-if="!props.row.trackingNumber" :loading="updateLoading" @update="updateTracking(props.row.orderNumber, $event)"></tracking-info>
          <shipping-info v-if="props.row.trackingNumber && !props.row.shippingCharges" :loading="updateLoading" @update="updateShipping(props.row.orderNumber, $event)"></shipping-info>
          <delivery-info v-if="props.row.shippingCharges && !props.row.deliverySignedBy" :loading="updateLoading" @update="updateDelivery(props.row.orderNumber, $event)"></delivery-info>
          <span v-if="props.row.deliverySignedBy">Order is processed</span>
        </template>
      </template>
    </el-table-column> -->
            <el-table-column prop="orderNumber"
                             :label="$t('orders.orderNum')"
                             width="90" sortable="custom"></el-table-column>
            <el-table-column :label="$t('orders.orderDate')" width="110" sortable="custom">
                <template slot-scope="scope">
                    {{getDate(scope.row.placedAt)}}
                </template>
            </el-table-column>
            <el-table-column :label="$t('orders.timeStamp')" v-if="filter.status == 0 || filter.status == null">
                <template slot-scope="scope">
                    {{getTime(scope.row.placedAt, scope.row.status)}}
                </template>
            </el-table-column>
            <el-table-column prop="purchaseOrderNumber"
                             :label="$t('orders.purchaseOrderNum')"
                             sortable="custom"></el-table-column>
            <el-table-column prop="shippingMethod"
                             :label="$t('common.shippingMethod')"
                             sortable="custom"></el-table-column>
            <el-table-column prop="serviceCompany"
                             :label="$t('orders.svcCompany')" sortable="custom"></el-table-column>
            <el-table-column v-if="$i18n.locale == 'en'" prop="status"
                             :label="$t('common.status')"
                             width="100" sortable="custom"></el-table-column>
            <el-table-column v-else prop="statusFr"
                             :label="$t('common.status')"
                             width="100" sortable="custom"></el-table-column>
            <el-table-column prop="trackingNumber"
                             :label="$t('common.trackingNumber')" sortable="custom"></el-table-column>
            <el-table-column prop="serviceOrderNumber"
                             :label="$t('orders.serviceOrderNum')" sortable="custom"></el-table-column>
            <el-table-column :label="$t('orders.shippingCharges')" sortable="custom">
                <template slot-scope="scope">
                    {{scope.row.shippingCharges | money}}
                </template>
            </el-table-column>
            <el-table-column prop="deliverySignedBy"
                             :label="$t('orders.deliverySignedBy')" sortable="custom"></el-table-column>

            <el-table-column :label="$t('orders.deliverySignedOn')" sortable="custom">
                <template slot-scope="scope">
                    {{scope.row.deliveryDate | datetime}}
                </template>
            </el-table-column>
            <el-table-column :label="$isUser ? $t('common.view') : $t('common.operations')"
                             fixed="right"
                             width="160">
                <template slot-scope="scope">
                    <el-button size="mini"
                               @click="viewOrder(scope.row.orderNumber)">
                        <i class="el-icon-view"></i>
                    </el-button>
                    <el-button size="mini"
                               type="danger"
                               @click="deletePartOrder(scope.row.orderNumber)"
                               v-if="$isFullAdmin && scope.row.status != 'Processed' && scope.row.status != 'Deleted'">
                        <i class="el-icon-delete"></i>
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination class="pager"
                       v-if="total !== 0"
                       @current-change="handleCurrentChange"
                       :current-page.sync="currentPage"
                       :page-size="15"
                       layout="total, prev, pager, next"
                       :total="total">
        </el-pagination>

        <create-update-part-order-dialog :visible="dialogVisible"
                                         :orderId="orderToView"
                                         @dialogClosed="dialogClosed"></create-update-part-order-dialog>
    </div>
</template>

<script>
    import api from "../api";
    import CreateUpdatePartOrderDialog from "./CreateUpdatePartOrderDialog";
    import TrackingInfo from "./TrackingInfo";
    import ShippingInfo from "./ShippingInfo";
    import DeliveryInfo from "./DeliveryInfo";
    import { EventBus } from "@/app/event-bus.js";

    export default {
        name: "part-order-list",
        components: {
            CreateUpdatePartOrderDialog,
            TrackingInfo,
            ShippingInfo,
            DeliveryInfo
        },
        computed: {
            getTime() {
                return (placedAt, status) => {
                    if (status == "New") {
                        return new Date(placedAt).toLocaleTimeString();
                    } else {
                        return "";
                    }
                }
            },
            getDate() {
                return (placedAt) => {
                    return new Date(placedAt).toLocaleDateString();
                }
            }
        },
        data() {
            return {
                orders: [],
                dialogVisible: false,
                orderToView: null,
                filter: {
                    status: this.$route.params.status || null,
                    partOrderNumber: "",
                    serviceCompanyName: "",
                    purchaseOrderNumber: ""
                },
                sorting: {},
                categories: [],
                loading: true,
                // updateLoading: false,
                currentPage: 1,
                total: 0
            };
        },
        watch: {
            filter: {
                deep: true,
                handler: function (val) {
                    if (this.filter.status === null && this.$route.params.status != null) {
                        window.location.href = "/#/part-orders";
                    }
                    this.loadOrders();
                    this.loadCategories();
                }
            }
        },
        created() {
            this.loadOrders();
            this.loadCategories();
        },

        mounted() {
            var self = this;
            EventBus.$on("order-placed", order => {
                // self.orders.push(order);
                this.loadOrders();
                this.loadCategories();
            });
        },
        beforeDestroy() {
            EventBus.$off("order-placed");
        },
        methods: {
            parseDate(str) {
                return str.slice(0, 10).split("-");
            },
            parseTime(str) {
                return str.slice(str.indexOf("T") + 1, str.indexOf("T") + 9).split(":");
            },
            loadOrders() {
                this.loading = true;
                api.getOrders(this.currentPage, this.filter, this.sorting).then(response => {
                    this.orders = response.data.items;
                    this.orders = response.data.items.map(obj => {
                        let statusFrench = this.mapSatusFr(obj.status);
                        return {
                            ...obj, statusFr: statusFrench
                        }
                    });
                    console.log(this.orders);
                    this.total = response.data.total;
                    this.loading = false;
                });
            },
            mapSatusFr(status) {
                switch (status) {
                    case "Open":
                        return "Ouvrir";
                    case "New":
                        return "Nouveau";
                    case "Processed":
                        return "Traité";
                    case "Deleted":
                        return "Supprimé";
                    default:
                        return "";
                }
            },
            sortPartOrders(sort) {
                let sortBy = sort.prop;
                if (!sortBy && sort.column != null) {
                    sortBy = sort.column.label;
                }
                let sortOrder = sort.order;
                this.sorting = {
                    sortBy,
                    sortOrder
                };
                if (this.currentPage === 1) {
                    this.loadOrders();
                } else {
                    this.currentPage = 1;
                }
            },
            // updateTracking(id, data) {
            //   this.updateLoading = true;
            //   api.updateTrackingInfo(id, data).then(response => {
            //     var order = this.orders.find(o => o.orderNumber === id);
            //     Object.assign(order, data);
            //     this.updateLoading = false;
            //   });
            // },
            // updateShipping(id, data) {
            //   this.updateLoading = true;
            //   api.updateShippingInfo(id, data).then(response => {
            //     var order = this.orders.find(o => o.orderNumber === id);
            //     Object.assign(order, data);
            //     this.updateLoading = false;
            //   });
            // },
            // updateDelivery(id, data) {
            //   this.updateLoading = true;
            //   api.updateDeliveryInfo(id, data).then(response => {
            //     var order = this.orders.find(o => o.orderNumber === id);
            //     Object.assign(order, data);
            //     this.updateLoading = false;
            //     this.loadOrders();
            //   });
            // },
            viewOrder(id) {
                this.orderToView = id;
                this.dialogVisible = true;
                document.title = "PARTS ORDER";
            },
            handleCurrentChange(page) {
                this.currentPage = page;
                this.loadOrders();
            },
            loadCategories() {
                this.loading = true;
                api.getCategories().then(response => {
                    this.loading = false;
                    this.categories = response.data;
                });
            },
            dialogClosed() {
                this.loadOrders();
                this.loadCategories();
                this.dialogVisible = false;
                document.title = "Service Claim Processing";
            },
            deletePartOrder(id) {
                this.$confirm(
                    this.$t('common.areYouSureYouWantToDeleteThePartOrder'),
                    "Warning",
                    {
                        confirmButtonText: this.$t('common.OK'),
                        cancelButtonText: this.$t('common.cancel'),
                        type: "warning"
                    }
                )
                    .then(() => {
                        api
                            .deleteOrder(id)
                            .then(() => {
                                this.loadOrders();
                                this.loadCategories();
                                this.$message({
                                    type: "success",
                                    message: this.$t('common.thePartOrderIsSuccessfullyDeleted')
                                });
                            })
                            .catch(err => {
                                console.log(err);
                            });
                    })
                    .catch(_ => { });
            }
        }
    };
</script>

<style scoped>
    .orders-table {
        width: 100%;
        margin-top: 20px;
    }

        .orders-table p {
            margin-top: 0;
        }
</style>



// WEBPACK FOOTER //
// ClientApp/app/orders/components/PartOrderList.vue